import { render, staticRenderFns } from "./inspectionRecordForm.vue?vue&type=template&id=78a1f4b2&scoped=true"
import script from "./inspectionRecordForm.vue?vue&type=script&lang=js"
export * from "./inspectionRecordForm.vue?vue&type=script&lang=js"
import style0 from "./inspectionRecordForm.vue?vue&type=style&index=0&id=78a1f4b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a1f4b2",
  null
  
)

export default component.exports